import { MaterialRequest } from "../services/MaterialRequestGraphQLService";

export class MaterialRequestOverviewViewModel {
  public itemsPerPage = 25;
  public search = "";

  public headers = [
    { text: "Erledigt?", value: "done", width: "150px" },
    { text: "Datum", value: "date" },
    { text: "Mitarbeiter", value: "employeeName" },
    { text: "", value: "actions", align: "right" }
  ];
  public items: MaterialRequest[] = [];
  public totalItems = 0;
  public options = {
    groupBy: [],
    groupDesc: [],
    itemsPerPage: this.itemsPerPage,
    multiSort: true,
    mustSort: false,
    sortBy: ["done", "date"],
    sortDesc: [false, true]
  };
  public loading = true;
  public pageNumber = 1;
}
